export default __webpack_public_path__ + "static/media/services-4.1d07d1ba.jpg";